__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "@quality24/feedback-container-app";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@apollo/client", "3.11.1", () => (() => (__webpack_require__(2760))), 1);
			register("@fortawesome/fontawesome-svg-core", "6.4.0", () => (() => (__webpack_require__(8669))), 1);
			register("@fortawesome/pro-regular-svg-icons", "6.4.0", () => (() => (__webpack_require__(4065))), 1);
			register("@fortawesome/react-fontawesome", "0.2.6", () => (() => (__webpack_require__(5291))), 1);
			register("@quality24/design-system", "2.58.0", () => (() => (__webpack_require__(6017))), 1);
			register("@quality24/feedback-react-token-auth", "1.7.3", () => (() => (__webpack_require__(4532))), 1);
			register("@quality24/react-hooks", "1.8.4", () => (() => (__webpack_require__(2914))), 1);
			register("classnames", "2.3.2", () => (() => (__webpack_require__(5932))), 1);
			register("i18next", "23.16.8", () => (() => (__webpack_require__(4886))), 1);
			register("js-cookie", "3.0.1", () => (() => (__webpack_require__(5309))), 1);
			register("jwt-decode", "3.1.2", () => (() => (__webpack_require__(4103))), 1);
			register("lodash", "4.17.21", () => (() => (__webpack_require__(2167))), 1);
			register("react-dom", "18.3.1", () => (() => (__webpack_require__(31))), 1);
			register("react-helmet", "6.1.0", () => (() => (__webpack_require__(9665))), 1);
			register("react-responsive", "9.0.2", () => (() => (__webpack_require__(2254))), 1);
			register("react-router", "7.13.2", () => (() => (__webpack_require__(6060))), 1);
			register("react", "18.3.1", () => (() => (__webpack_require__(7910))), 1);
			register("web-vitals", "2.1.4", () => (() => (__webpack_require__(6151))), 1);
			initExternal(7659);
			initExternal(9917);
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};